module.exports = __webpack_public_path__ + "img/error_icon_dark.b6408982.svg";